import { MATCH_TYPE } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/constants';
import { MatchTypeValue, OverrideLogicKey } from './types';

export const getOverrideLogicLabelKey = (type: MatchTypeValue): OverrideLogicKey => {
  if (MATCH_TYPE.mismatch.includes(type)) return 'hide';
  if (MATCH_TYPE.exact.includes(type)) return 'show';
  return 'na';
};
